import React, { FC } from "react";

import { Button as MuiButton, makeStyles } from "@material-ui/core";
import { ButtonProps } from "@material-ui/core/Button";
import { Colors } from "../../styles";

const buttonColors = {
    primary: {
        backgroundColor: Colors.mellowYellow,
        backgroundColorPressed: Colors.pumpkinTwo,
        textColor: Colors.white,
        hoverColor: Colors.pumpkin,
        borderColor: undefined,
    },
    secondary: {
        backgroundColor: Colors.anthracite5,
        backgroundColorPressed: Colors.paleTwo,
        textColor: Colors.anthracite,
        hoverColor: Colors.eggshell,
        borderColor: undefined,
    },
    important: {
        backgroundColor: Colors.pulsingPurple,
        backgroundColorPressed: Colors.deepViolett,
        textColor: Colors.white,
        hoverColor: Colors.velvet,
        borderColor: undefined,
    },
    action: {
        backgroundColor: Colors.white,
        backgroundColorPressed: Colors.white,
        textColor: Colors.mellowYellow,
        hoverColor: Colors.anthracite5,
        borderColor: Colors.mellowYellow,
    },
};

type Props = ButtonProps & {
    mode: keyof typeof buttonColors;
};

const useStyles = makeStyles({
    button: (props: Props) => ({
        backgroundColor: buttonColors[props.mode].backgroundColor,
        color: buttonColors[props.mode].textColor,

        height: 56,
        borderRadius: 28,
        border: `solid 2px ${buttonColors[props.mode].borderColor}`,
        boxShadow: "none",
        opacity: 1,

        textTransform: "none",

        fontSize: 22,
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: 1.27,
        letterSpacing: "normal",

        paddingLeft: 44,
        paddingRight: 44,

        "&:active:not(hover)": {
            background: buttonColors[props.mode].backgroundColorPressed,
        },
        "&:hover": {
            background: buttonColors[props.mode].hoverColor,
        },
        "&:disabled": {
            background: Colors.anthracite25,
            color: Colors.white,
        },
        "&focused": {
            background: buttonColors[props.mode].backgroundColorPressed,
        },
    }),
});

export const Button: FC<Props> = (props: Props) => {
    const { ...other } = props;
    const classes = useStyles(props);

    return <MuiButton className={classes.button} disableTouchRipple {...other} />;
};
